/** 协议文档类型 → 接口 code */
export const legalDocumentCodes = {
  'user-agreement': 'USER_AGREEMENT',
  'privacy-policy': 'PRIVACY_POLICY'
}

/** 产品 key → 接口 channel（须显式传递，勿省略） */
export const legalChannels = {
  lengfeng: 'LENGFENG',
  fengyinbao: 'FENGYINBAO'
}

export const legalDocumentLabels = {
  'user-agreement': '用户协议',
  'privacy-policy': '隐私政策'
}

export const legalAppOptions = [
  { key: 'lengfeng', name: '冷丰', channel: 'LENGFENG' },
  { key: 'fengyinbao', name: '丰银宝', channel: 'FENGYINBAO' }
]

export const legalDocumentOptions = [
  { key: 'user-agreement', label: '用户协议', code: 'USER_AGREEMENT' },
  { key: 'privacy-policy', label: '隐私政策', code: 'PRIVACY_POLICY' }
]

/** 页脚等入口：冷丰 / 丰银宝 × 用户协议 / 隐私政策 */
export function getLegalNavLinks() {
  return legalAppOptions.flatMap((app) =>
    legalDocumentOptions.map((doc) => ({
      to: `/legal/${app.key}/${doc.key}`,
      label: `${app.name}${doc.label}`
    }))
  )
}

export function getProtocolCode(documentKey) {
  return legalDocumentCodes[documentKey] || null
}

export function getProtocolChannel(appKey) {
  return legalChannels[appKey] || null
}

export function getLegalDocumentLabel(documentKey) {
  return legalDocumentLabels[documentKey] || '法律文档'
}

export function getLegalAppName(appKey) {
  return legalAppOptions.find((app) => app.key === appKey)?.name || ''
}

export function isValidLegalRoute(appKey, documentKey) {
  return Boolean(getProtocolChannel(appKey) && getProtocolCode(documentKey))
}
